<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>

  <div v-else class="ui segment">
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="syringe icon"></i>
        <div class="content">
          {{ item.name }}
        </div>
      </h2>
    </div>

    <br/>

      <h4 class="ui dividing header">
        Basic Infromation
      </h4>
      <abstractTable :data="itemInfo"
                     :definitionTable="true"
                     :definitionTableWidth="'20%'"
                     :classes="'ui compact definition table'">
      </abstractTable>

      <br/>

      <h4 class="ui dividing header">
        Invoices Infromation
      </h4>

      <invoicesPart :item="item" :suppliers="suppliers" v-if="$auth.user().see_invoices" />

      <h4 class="ui dividing header">
        Packages Information
      </h4>
      <div class="ui blue button"
           style="background-color: #092442"
           @click="showModal()"
           v-if="isAdmin()"
      >
        Add Package
      </div>
      <abstractTable :columns="packageColumns" :data="computedPackage()"
                     style="padding-top: 10px;"
                     :classes="'ui tablet very compact center aligned very basic celled table'"
                     v-if="computedPackage().length">
      </abstractTable>

      <div class="ui large longer modal" id="package" style="margin-top: 20px !important;">
        <div class="header">New Package for {{ item.name }}</div>
          <newPackage
            :object="item"
            :apiURL="`items/${item.id}/add/package`"
            :p="package"
          />
      </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    invoicesPart: require('@/components/inventory_system/items/item_components/InvoicesPart').default,
    newPackage: require('@/components/packages/NewPackage').default
  },
  data () {
    return {
      package: {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null
      },
      item: {},
      itemCategory: {},
      suppliers: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get(`items/${this.$route.params.id}`, {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.item = response.data.item
      this.item.packages = response.data.meta.packages
      this.itemCategory = response.data.meta.item_category
      this.suppliers = response.data.meta.suppliers
      this.loading = false
    })
  },
  computed: {
    itemInfo () {
      return {
        id: this.item.id,
        name: this.item.name,
        description: this.item.description || '-',
        category: this.itemCategory ? this.itemCategory.name : '-',
        real_code: this.item.real_code || '-',
        system_code: this.displaySystemCode(this.item.system_code),
        down_quantity_limit: this.item.down_quantity_limit,
        quantity_in_stock: this.item.quantity_in_stock,
        recommanded_unit_price: this.item.recommanded_unit_price,
        unit_measurement: this.item.unit_measurement.name,
        item_size: this.item.item_size ? this.item.item_size.name : '-'
      }
    },
    packageColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Description', fieldName: 'description', show: true },
        { header: 'Price', fieldName: 'unit_price', show: true },
        { header: 'Quantity', fieldName: 'quantity', show: true },
        { header: 'Started At', fieldName: 'started_at', show: true },
        { header: 'Finished At', fieldName: 'finished_at', show: true }
      ]
    },
  },
  methods: {
    computedPackage () {
      let formlatedPackages = []

      window._.each(this.item.packages, selectedpackage => {
        formlatedPackages.push({
          name: selectedpackage.name,
          description: selectedpackage.description,
          unit_price: this.formatPrice(selectedpackage.unit_price),
          quantity: selectedpackage.quantity,
          started_at: window.moment(selectedpackage.started_at).format('DD/MM/YYYY - hh:mm a'),
          finished_at: selectedpackage.finished_at
            ? window.moment(selectedpackage.started_at).format('DD/MM/YYYY - hh:mm a') : '-'
        })
      })

      return formlatedPackages
    },
    displaySystemCode (code) {
      if (code.length < 3) {
        return '0'.repeat(3 - code.length) + code
      }

      return code
    },
    initPackage () {
      this.package = {
        name: '',
        unit_price: null,
        description: '',
        quantity: null,
        started_at: null,
        finished_at: null
      }
    },
    showModal () {
      $('#package').modal({
        onHidden: () => {
          this.initPackage()
        },
        onShow: () => {
          this.initGUI()
        }
      }).modal('show').modal('refresh')
      this.initGUI()
    },
    initGUI () {
      this.$nextTick(() => {
        $('#start-at').calendar({
          type: 'datetime',
          minDate: new Date(),
          onChange: (date) => {
            this.package.started_at = date
          }
        })

        $('#finish-at').calendar({
          type: 'datetime',
          minDate: this.package.start_at,
          onChange: (date) => {
            this.package.finished_at = date
          }
        })
      })
    }
  },
  beforeDestroy () {
    $('#package').remove()
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/items/Item.vue